import { AccordionItemProvider } from '../contexts/accordion-item-context';
import { SimpleAccordionItemContainer } from '../simple-accordion-item-container';

export const SimpleAccordionItem = ({ 
	value,
	className,
	hasSummary = true,
	isSelected,
	children 
}: {
	value: string;
	className?: string;
	hasSummary?: boolean;
	isSelected?: boolean;
	children: React.ReactNode;
}) => {
	return (
		<AccordionItemProvider 
			value={value} 
			isSelected={isSelected}
		>
			<SimpleAccordionItemContainer 
				className={className}
				hasSummary={hasSummary}
			>
				{children}
			</SimpleAccordionItemContainer>
		</AccordionItemProvider>
	);
};